import React from 'react';
import { ArrowLeftRightIcon } from 'lucide-react';
import { useAppState } from '../../contexts/AppStateContext';
import { copy } from '../../data/copy';
import { formatTimeOfDay } from '../../utils/time';
import { Button } from '../ui/Button';
import { EmptyNote } from '../ui/Panel';
import { Avatar } from '../Avatar';
export function OfferBoard() {
  const {
    family,
    familyOcc,
    memberById,
    viewer,
    takeOffer,
    cancelOffer
  } = useAppState();
  const open = family.templates.filter(t => familyOcc[t.id]?.offer && !familyOcc[t.id]?.takenBy);
  const taken = family.templates.filter(t => familyOcc[t.id]?.takenBy);
  return <div className="space-y-6" data-id="element-185" data-mp="1wrwsdroabwv1">
      <div className="rounded-2xl bg-info-soft p-4 text-sm text-info-ink" data-id="element-186" data-mp="1wqlmnmba4f1a">
        <p className="font-bold" data-id="element-187" data-mp="21pojijh3vey6">Kako deluje prevzem?</p>
        <p className="mt-1" data-id="element-188" data-mp="2pgtxsu7edz6d">
          Kdor ne utegne, nalogo <b data-id="element-189" data-mp="2pf0qrdsvhcxu">ponudi</b> enemu članu ali vsem. Dokler je nihče ne sprejme, ostane njegova. Ko jo nekdo <b data-id="element-190" data-mp="2u94y3y61vmzg">prevzame</b>, velja samo za ta
          termin – točke dobi tisti, ki jo res opravi.
        </p>
      </div>
      {open.length === 0 ? <EmptyNote data-id="element-191" data-mp="8fvhh9irx1ky">{copy.emptyOffers}</EmptyNote> : <ul className="grid gap-3 md:grid-cols-2" data-id="element-192" data-mp="8diswdiifsyx">
          {open.map(t => {
        const o = familyOcc[t.id];
        const by = memberById(o.offer?.byId);
        const forMe = o.offer?.toId === 'vsi' || o.offer?.toId === viewer.id;
        const own = o.offer?.byId === viewer.id;
        return <li key={t.id} className="flex flex-col rounded-3xl border-[1.5px] border-line bg-surface p-4" data-id="element-193" data-mp="r6cyigu8u8qh">
                <div className="flex items-start gap-3" data-id="element-194" data-mp="155url8eko85n">
                  {by && <Avatar member={by} data-id="element-195" data-mp="1538ih4c19klb" />}
                  <span className="min-w-0 flex-1" data-id="element-196" data-mp="107kwexsul7k1">
                    <span className="block font-display text-lg font-semibold leading-tight" data-id="element-197" data-mp="104oyvakwwkw4">{t.title}</span>
                    <span className="block text-xs text-muted" data-id="element-198" data-mp="31xwd0gosgwgf">
                      {by?.name} → {o.offer?.toId === 'vsi' ? 'vsem' : memberById(o.offer?.toId)?.name} · ob {formatTimeOfDay(o.offer?.at ?? 0)}
                    </span>
                  </span>
                  {t.baseValue ? <span className="rounded-full bg-sun-soft px-2 py-0.5 text-xs font-extrabold text-sun-ink" data-id="element-199" data-mp="1avxeozz945gg">{t.baseValue} t.</span> : null}
                </div>
                <div className="mt-auto flex justify-end pt-3" data-id="element-200" data-mp="1jvkgvnzt1fak">
                  {own ? <Button size="sm" variant="secondary" onClick={() => cancelOffer(t.id)} data-id="element-201" data-mp="1oudtzfb6j4a7">
                      Prekliči ponudbo
                    </Button> : forMe ? <Button size="sm" onClick={() => takeOffer(t.id)} data-id="element-202" data-mp="1yj5j7fouvahf">
                      <ArrowLeftRightIcon className="h-4 w-4" aria-hidden="true" data-id="element-203" data-mp="23iig6t9fxxxq" /> Prevzamem
                    </Button> : <span className="text-xs text-muted" data-id="element-204" data-mp="27letc4g7p1ua">Ponujeno drugemu članu</span>}
                </div>
              </li>;
      })}
        </ul>}
      {taken.length > 0 && <div data-id="element-205" data-mp="x4qirqiea5t">
          <h3 className="mb-2 text-sm font-extrabold" data-id="element-206" data-mp="tqmzg63zuws">Prevzeto ta termin</h3>
          <ul className="divide-y divide-line rounded-3xl border-[1.5px] border-line bg-surface" data-id="element-207" data-mp="3s0l22hxnezwv">
            {taken.map(t => <li key={t.id} className="px-4 py-2.5 text-sm" data-id="element-208" data-mp="3o2dsq85il0vp">
                <b data-id="element-209" data-mp="3j30wwxwo0jgz">{t.title}</b>: {memberById(familyOcc[t.id].offer?.byId)?.name} → {memberById(familyOcc[t.id].takenBy)?.name}
              </li>)}
          </ul>
        </div>}
    </div>;
}